import NursingQuestionsTable from "./NursingQuestionsTable";

// The hosting uib-tab destroys and recreates its pane on every tab switch, so this section
// remounts (and the list query refetches) each time the tab is entered — no refresh plumbing
// is needed for Angular-side edits to show up.
export default function NursingQuestionSettingsSection() {
  return <NursingQuestionsTable />;
}
